import { createSlice } from "@reduxjs/toolkit";

const buttonSlice = createSlice({
  name: "button",
  initialState: false,
  reducers: {
    startSubmitting: () => true,
    stopSubmitting: () => false,
  },
});

export const { startSubmitting, stopSubmitting } = buttonSlice.actions;

export default buttonSlice.reducer;
